<script setup>
import {computed} from "vue";
import {Link} from "@inertiajs/vue3";
import {Icon} from "@iconify/vue";

const props = defineProps({
    notification: {
        type: Object,
        required: true,
    },
});

// One renderer for every kb-* notification type. Iconography is keyed off the
// type slug with a sensible default, so new KB notifications render without a
// new component as long as they follow the uniform payload contract.
const iconMap = {
    "kb-learning-assigned": "lucide:graduation-cap",
    "kb-learning-step-due-soon": "lucide:clock",
    "kb-learning-step-overdue": "lucide:alarm-clock",
    "kb-submission-passed": "lucide:circle-check",
    "kb-submission-failed": "lucide:circle-x",
    "kb-submission-awaiting-grade": "lucide:clipboard-check",
    "kb-assignment-completed": "lucide:badge-check",
    "kb-assignment-cancelled": "lucide:ban",
    "kb-assignment-mandatory-step-added": "lucide:list-plus",
    "kb-page-requires-acknowledgement": "lucide:file-check",
    "kb-learning-track-updated": "lucide:refresh-cw",
};

const icon = computed(() => iconMap[props.notification.type] ?? "lucide:bell");
const data = computed(() => props.notification.data ?? {});
</script>

<template>
    <div class="flex gap-5 items-start">
        <span class="shrink-0 flex h-24 w-24 items-center justify-center rounded-full bg-light-3 text-dark-light">
            <Icon :icon="icon" width="18" />
        </span>
        <div class="flex flex-col text-sm">
            <component :is="data.url ? Link : 'span'"
                       :href="data.url"
                       class="font-semibold">
                {{ data.title }}
            </component>
            <span v-if="data.context"
                  class="text-dark-light">{{ data.context }}</span>
            <span class="text-accent-blue">{{ notification.created_at }}</span>
        </div>
    </div>
</template>
